import { render, staticRenderFns } from "./cbdoil.vue?vue&type=template&id=2e948518&scoped=true&"
import script from "./cbdoil.vue?vue&type=script&lang=js&"
export * from "./cbdoil.vue?vue&type=script&lang=js&"
import style0 from "./cbdoil.vue?vue&type=style&index=0&id=2e948518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e948518",
  null
  
)

export default component.exports